<div class="shop-antifraud-limits-settings">
  <div class="page-header">
    <div class="page-title">Limites antifraude loja | Checkout cartão</div>
    <p class="page-description">
      Define os tetos de volume (compras e falhas) do antifraude de
      <strong>cartão</strong> na loja, por
      <strong>assinante</strong> e <strong>não assinante</strong>. Alterações
      valem no checkout em até ~1 minuto, sem deploy.
    </p>
    <div class="fallback-note">
      <i class="pi pi-info-circle"></i>
      <span>
        Se a config estiver ausente ou inválida, o checkout usa os defaults de
        segurança: assinante
        <strong>4 / 12 / 7</strong> e não assinante
        <strong>2 / 7 / 5</strong> (compras/dia · compras/semana · falhas/dia).
        <ng-container *ngIf="sourceStatus">
          <br />
          {{ sourceStatus }}
        </ng-container>
      </span>
    </div>
    <div class="fallback-note fallback-note--warn" *ngIf="source === 'invalid'">
      <i class="pi pi-exclamation-triangle"></i>
      <span>
        A configuração salva está inválida. O checkout já está nos defaults;
        corrija os campos e salve de novo para voltar a valer.
      </span>
    </div>
  </div>

  <form class="form-b4a config-card" [formGroup]="form" (ngSubmit)="save()">
    <div class="config-card__header">
      <div>
        <h2>Limites de volume (cartão)</h2>
        <p>
          Ajuste os tetos de volume do checkout de cartão e informe o motivo.
          O toggle desliga todos os AntifraudProviders (cartão, boleto, PIX,
          glampoints).
        </p>
      </div>
      <div class="enabled-toggle">
        <label for="antifraud-enabled">Antifraude ativo</label>
        <p-inputSwitch
          inputId="antifraud-enabled"
          formControlName="enabled"
        />
      </div>
    </div>

    <section class="limits-section" formGroupName="day">
      <h3>Compras por dia</h3>
      <div class="limits-grid">
        <div class="profile-card" formGroupName="subscriber">
          <h4>Assinante</h4>
          <div class="field" *ngFor="let field of limitFields">
            <label [for]="'day-sub-' + field">{{ fieldLabel(field) }}</label>
            <p-inputNumber
              [inputId]="'day-sub-' + field"
              [formControlName]="field"
              [min]="1"
              [max]="50"
              [showButtons]="true"
            />
          </div>
        </div>
        <div class="profile-card" formGroupName="nonSubscriber">
          <h4>Não assinante</h4>
          <div class="field" *ngFor="let field of limitFields">
            <label [for]="'day-non-' + field">{{ fieldLabel(field) }}</label>
            <p-inputNumber
              [inputId]="'day-non-' + field"
              [formControlName]="field"
              [min]="1"
              [max]="50"
              [showButtons]="true"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="limits-section" formGroupName="week">
      <h3>Compras por semana</h3>
      <div class="limits-grid">
        <div class="profile-card" formGroupName="subscriber">
          <h4>Assinante</h4>
          <div class="field" *ngFor="let field of limitFields">
            <label [for]="'week-sub-' + field">{{ fieldLabel(field) }}</label>
            <p-inputNumber
              [inputId]="'week-sub-' + field"
              [formControlName]="field"
              [min]="1"
              [max]="200"
              [showButtons]="true"
            />
          </div>
        </div>
        <div class="profile-card" formGroupName="nonSubscriber">
          <h4>Não assinante</h4>
          <div class="field" *ngFor="let field of limitFields">
            <label [for]="'week-non-' + field">{{ fieldLabel(field) }}</label>
            <p-inputNumber
              [inputId]="'week-non-' + field"
              [formControlName]="field"
              [min]="1"
              [max]="200"
              [showButtons]="true"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="limits-section" formGroupName="blockedAttemptsDay">
      <h3>Falhas / bloqueios por dia</h3>
      <div class="limits-grid limits-grid--blocked">
        <div class="field">
          <label for="blocked-sub">Assinante</label>
          <p-inputNumber
            inputId="blocked-sub"
            formControlName="subscriber"
            [min]="1"
            [max]="50"
            [showButtons]="true"
          />
        </div>
        <div class="field">
          <label for="blocked-non">Não assinante</label>
          <p-inputNumber
            inputId="blocked-non"
            formControlName="nonSubscriber"
            [min]="1"
            [max]="50"
            [showButtons]="true"
          />
        </div>
      </div>
    </section>

    <div class="field reason-field">
      <label for="antifraud-reason">Motivo da alteração (obrigatório)</label>
      <input
        id="antifraud-reason"
        type="text"
        pInputText
        formControlName="reason"
        maxlength="500"
        placeholder="Ex.: Live dia 08/08/2026"
      />
    </div>

    <div class="config-card__footer">
      <small class="config-card__updated">
        <i class="pi pi-shield"></i>
        Roles: Full Administrator, Financeiro, ItOps
      </small>
      <p-button
        type="submit"
        label="Salvar limites"
        icon="pi pi-check"
        [loading]="saving"
        [disabled]="saving"
      />
    </div>
  </form>
</div>
<p-toast />
